import styled from 'styled-components';

const SortBySelect = styled.div`
  color: #fff;
  font-size: 13px;
  line-height: 15px;
  text-transform: uppercase;
  font-family: 'Avenir Light', 'Arial', sans-serif;
  letter-spacing: 1px;
  font-weight: 900;
  text-decoration: none;
  width: 225px;
  height: 25px;
  background-color: black;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
`;

export default SortBySelect;
